import { useTranslation } from "react-i18next";

import { SNOOZE_TYPES } from "models";

import type { Dealer } from "models";

export const useSnoozeTypeOptions = (dealer?: Dealer | null) => {
  const { t } = useTranslation();

  return {
    snoozeTypeOptions: [
      {
        key: SNOOZE_TYPES.NextVisitCustomer,
        value: SNOOZE_TYPES.NextVisitCustomer,
        text: t("v8_next_visit_customer", "Next visit customer"),
        disabled: !dealer?.is_snooze_type_next_visit_customer_enabled
      },
      {
        key: SNOOZE_TYPES.MakeOffer,
        value: SNOOZE_TYPES.MakeOffer,
        text: t("v8_make_an_offer", "Make an offer"),
        disabled: !dealer?.is_snooze_type_make_offer_enabled
      },
      {
        key: SNOOZE_TYPES.MakeNewAppointment,
        value: SNOOZE_TYPES.MakeNewAppointment,
        text: t("v8_make_new_appointment", "Make new appointment"),
        disabled: !dealer?.is_snooze_type_make_new_appointment_enabled
      },
      {
        key: SNOOZE_TYPES.RemindCustomer,
        value: SNOOZE_TYPES.RemindCustomer,
        text: t("v8_remind_customer", "Remind customer"),
        disabled: !dealer?.is_snooze_type_remind_customer_enabled
      }
    ]
  };
};
